import { Component, Input, OnInit } from '@angular/core';
import {
  IMAGE_SRC,
  STATUS_OPTIONS,
} from 'src/app/components/shared/shared-constants';
import {
  AdlSecondCardData,
  AvailableDay,
  StartEnd,
} from 'src/app/core/models/admin';
import {
  AVAILABLE_HEADER_COLS,
  CLOSED_HEADER_COLS,
  HEADER_COLS,
  LABEL_ROW,
} from './availability-card.constants';

@Component({
  selector: 'app-availability-card',
  templateUrl: './availability-card.component.html',
  styleUrls: ['./availability-card.component.scss'],
  standalone: false,
})
export class AvailabilityCardComponent implements OnInit {
  @Input() cardData!: AdlSecondCardData;

  expandedAvailability: AvailableDay[] = [];
  expandedCloseDays: StartEnd[] = [];
  daysOfWeek: string[] = [''];

  readonly DAYS_OF_WEEK = HEADER_COLS;
  readonly AVAILABLE_HEADER_COLS = AVAILABLE_HEADER_COLS;
  readonly CLOSED_HEADER_COLS = CLOSED_HEADER_COLS;
  readonly IMAGES = IMAGE_SRC;
  readonly IMAGE_OPTIONS = STATUS_OPTIONS;
  readonly LABEL_ROW = LABEL_ROW;

  ngOnInit(): void {
    this.cardData.availableDays.forEach((day, dayOfWeek) => {
      day.forEach((value, index) => {
        if (index === 0) {
          const closeDay = this.cardData.closeDays[dayOfWeek];
          this.daysOfWeek.push(this.DAYS_OF_WEEK[dayOfWeek]);
          this.expandedAvailability.push(value);
          this.expandedCloseDays.push(
            closeDay ? closeDay : { start: '', end: '' },
          );
        } else {
          this.daysOfWeek.push('');
          this.expandedAvailability.push(value);
          this.expandedCloseDays.push({ start: '', end: '' });
        }
      });
    });
  }
}
